import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import useAuthStore from "../stores/authStore";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "./ManualPage.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export default function ManualPage() {
  const { userType } = useAuthStore();
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(900);
  const containerRef = useRef(null);

  const getManualPdfUrl = () => {
    switch (userType) {
      case "system":
      case "admin":
        return "/manuals/manual_admin.pdf";
      case "operator":
        return "/manuals/manual_operator.pdf";
      case "enduser":
      default:
        return "/manuals/manual_enduser.pdf";
    }
  };

  const pdfUrl = getManualPdfUrl();

  useEffect(() => {
    const updateWidth = () => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;

      // 余白分を引いて、最大900pxまでに制限
      const nextWidth = Math.min(containerWidth - 32, 900);

      setPageWidth(nextWidth > 0 ? nextWidth : 300);
    };

    updateWidth();

    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  return (
    <div className="manualPage">
      <div className="manualHeader">
        <h2>操作マニュアル</h2>

        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          PDFを別タブで開く
        </a>
      </div>

      <div className="manualPdfArea" ref={containerRef}>
        <Document
          file={pdfUrl}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          loading={<div className="manualLoading">マニュアルを読み込み中...</div>}
          error={<div className="manualError">マニュアルを表示できませんでした。</div>}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <div className="manualPdfPage" key={`page_${index + 1}`}>
              <Page
                pageNumber={index + 1}
                width={pageWidth}
                renderTextLayer={true}
                renderAnnotationLayer={true}
              />
            </div>
          ))}
        </Document>
      </div>
    </div>
  );
}